import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  createMeetingTypes,
  deleteMeetingTypes,
  getAllActiveMeetingTypes,
  getAllMeetingTypes,
  getMeetingTypesByID,
  MeetingTypesActiveInactive,
  updateMeetingTypes,
} from "./services/meetingtypes.services";
import { IMeetingTypes, IMeetingTypesState } from "./meetingtypesModel";

const initialState: IMeetingTypesState = {
  loading: false,
  formLoading: false,
  error: "",
  MeetingTypesList: [],
  MeetingTypesID: null,
  MeetingTypesDetail: {
    meeting_type: "",
    isactive: 1,
  },
};

const meetingtypeSlice = createSlice({
  name: "meetingtype",
  initialState,
  reducers: {
    clearMeetingTypesDetails: (state) => {
      state.MeetingTypesDetail = initialState.MeetingTypesDetail;
    },
    setMeetingTypesID: (state, action) => {
      state.MeetingTypesID = action.payload;
    },
    clearMeetingTypesID: (state) => {
      state.MeetingTypesID = initialState.MeetingTypesID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllMeetingTypes.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllMeetingTypes.fulfilled,
      (state, action: PayloadAction<IMeetingTypes[]>) => {
        state.loading = false;
        state.MeetingTypesList = action.payload || [];
      }
    );
    builder.addCase(getAllMeetingTypes.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.MeetingTypesList = [];
    });
    builder.addCase(getAllActiveMeetingTypes.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveMeetingTypes.fulfilled,
      (state, action: PayloadAction<IMeetingTypes[]>) => {
        state.loading = false;
        state.MeetingTypesList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveMeetingTypes.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.MeetingTypesList = [];
    });
    builder.addCase(createMeetingTypes.pending, (state) => {
      state.formLoading = false;
      state.error = "";
    });
    builder.addCase(createMeetingTypes.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createMeetingTypes.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateMeetingTypes.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateMeetingTypes.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateMeetingTypes.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteMeetingTypes.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteMeetingTypes.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteMeetingTypes.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(MeetingTypesActiveInactive.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(MeetingTypesActiveInactive.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(MeetingTypesActiveInactive.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getMeetingTypesByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getMeetingTypesByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.MeetingTypesDetail = action.payload;
    });
    builder.addCase(getMeetingTypesByID.rejected, (state, action) => {
      state.formLoading = false;
      state.MeetingTypesDetail = initialState.MeetingTypesDetail;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearMeetingTypesDetails,
  setMeetingTypesID,
  clearMeetingTypesID,
} = meetingtypeSlice.actions;
export default meetingtypeSlice.reducer;
